module.exports = __webpack_public_path__ + "images/a99f923f46bdc5ab2fc9d6ba5bbc273e10ed1fc83370ad99c0a64850973667ed.svg";